import type {
  ListVoucherAutoAssignmentRuleAssignmentGroupsQuery,
  ListVoucherAutoAssignmentRulesQuery,
} from '~/services/PromoService';

export const voucherAutoAssignmentRuleQueryKeys = {
  all: ['voucher-auto-assignment-rules'] as const,
  lists: () => [...voucherAutoAssignmentRuleQueryKeys.all, 'list'] as const,
  list: (filters: ListVoucherAutoAssignmentRulesQuery) =>
    [...voucherAutoAssignmentRuleQueryKeys.lists(), filters] as const,
  assignmentGroups: (filters: ListVoucherAutoAssignmentRuleAssignmentGroupsQuery = {}) =>
    [...voucherAutoAssignmentRuleQueryKeys.all, 'assignment-groups', filters] as const,
  detail: (ruleId: string) => [...voucherAutoAssignmentRuleQueryKeys.all, 'detail', ruleId] as const,
};
